// import React from 'react';
// import { View, Text, ActivityIndicator, StyleSheet, Modal } from 'react-native';
// import { useSessionStore } from '../../../../state/src/useSessionStore';
// import type { SessionState } from '../../../../state/src/useSessionStore';

// const GlobalLoader: React.FC = () => {
//   const isLoading = useSessionStore((s: SessionState) => s.isLoading);
//   const loadingMessage = useSessionStore((s: SessionState) => s.loadingMessage);

//   if (!isLoading) return null;

//   return (
//     <Modal
//       transparent={true}
//       animationType="fade"
//       visible={isLoading}
//       statusBarTranslucent={true}
//     >
//       <View style={styles.overlay}>
//         <View style={styles.container}>
//           <ActivityIndicator size="large" color="#e31837" />
//           <Text style={styles.message}>{loadingMessage}</Text>
//         </View>
//       </View>
//     </Modal>
//   );
// };

// const styles = StyleSheet.create({
//   overlay: {
//     flex: 1,
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   container: {
//     backgroundColor: 'white',
//     padding: 30,
//     borderRadius: 15,
//     alignItems: 'center',
//     minWidth: 200,
//     shadowColor: '#000',
//     shadowOffset: {
//       width: 0,
//       height: 2,
//     },
//     shadowOpacity: 0.25,
//     shadowRadius: 3.84,
//     elevation: 5,
//   },
//   message: {
//     marginTop: 15,
//     fontSize: 16,
//     color: '#333',
//     textAlign: 'center',
//     fontWeight: '500',
//   },
// });

// export default GlobalLoader;
import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet, Platform } from 'react-native';
import { useSessionStore } from '../../../../state/src/useSessionStore';
import type { SessionState } from '../../../../state/src/useSessionStore';

const GlobalLoader: React.FC = () => {
  const isLoading = useSessionStore((s: SessionState) => s.isLoading);
  const loadingMessage = useSessionStore((s: SessionState) => s.loadingMessage);

  if (!isLoading) return null;

  // Use full-screen overlay instead of Modal on web
  if (Platform.OS === 'web') {
    return (
      <View style={styles.overlay}>
        <View style={styles.container}>
          <ActivityIndicator size="large" color="#e31837" />
          <Text style={styles.message}>{loadingMessage}</Text>
        </View>
      </View>
    );
  }

  // Native (iOS/Android) → keep Modal
  const { Modal } = require('react-native');
  return (
    <Modal
      transparent
      animationType="fade"
      visible={isLoading}
      statusBarTranslucent
    >
      <View style={styles.overlay}>
        <View style={styles.container}>
          <ActivityIndicator size="large" color="#e31837" />
          <Text style={styles.message}>{loadingMessage}</Text>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'absolute', // ensure overlay covers whole app
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // make sure it's on top of everything
  },
  container: {
    backgroundColor: 'white',
    padding: 30,
    borderRadius: 15,
    alignItems: 'center',
    minWidth: 200,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  message: {
    marginTop: 15,
    fontSize: 16,
    color: '#333',
    textAlign: 'center',
    fontWeight: '500',
  },
});

export default GlobalLoader;
